import * as React from 'react'
import { Link } from '@tanstack/react-router'
import { AppBar, Toolbar, Button, Typography, Box, Menu, MenuItem } from '@mui/material'
import logoUrl from '../../assets/floodnet_logo_bw_5in.png'
import { WEATHER_CONDITIONS } from '../../config'

export default function NavBar() {
  return (
    <AppBar position="sticky" color="default" elevation={6}>
        <Toolbar variant="dense" sx={{ gap: 1, overflowX: 'auto' }}>
        <img src={logoUrl} alt="FloodNet Logo" style={{ height: 32, verticalAlign: 'middle' }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 800, letterSpacing: 0.5, flexShrink: 0 }}>
            FloodNet NYC
        </Typography>
        <NavButton to="/" label="Map" />
        
        <NavButton to="/events" label="Storm Events" />
        {/* <NavButton to="/calendar" label="Calendar" /> */}
        <NavButton to="/lunar" label="Moon" />
        <NavButton to="/sensors" label="Sensors" />
        {/* <NavButton to="/download" label="Data Tool" /> */}
        {/* <WeatherMenu /> */}
        </Toolbar>
    </AppBar>
  )
}

function NavButton({ to, label }: { to: string; label: string }) {
  return (
    <Button
      component={Link}
      to={to}
      activeProps={{ style: { fontWeight: 700 } }}
      size="small"
      sx={{
        textTransform: 'none',
        fontWeight: 600,
        color: 'text.primary',
        borderRadius: 999,
        flexShrink: 0,
      }}
    >
      {label}
    </Button>
  )
}

function WeatherMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleOpen = (e: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(e.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <Button
        size="small"
        onClick={handleOpen}
        sx={{ textTransform: 'none', fontWeight: 600, color: 'text.primary', borderRadius: 999, flexShrink: 0 }}
      >
        Weather
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} keepMounted>
        {WEATHER_CONDITIONS.map((c) => (
          <MenuItem
            key={c.key}
            component={Link}
            to={`/weather/${c.key}`}
            onClick={handleClose}
          >
            {c.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
